// Source: app/scripts/controllers/auction-participation-request.js
/**
 * Created by ristes on 20.4.15.
 */



Auction.controller('AuctionParticipationRequestController', [
  '$scope',
  '$filter',
  '$sce',
  '$modal',
  'toaster',
  'AuctionParticipationRequest',
  function ($scope, $filter, $sce, $modal, toaster, AuctionParticipationRequest) {

    $scope.rejectEntity = {};
    $scope.modalReject = $modal({
      scope: $scope,
      template: 'forms/modals/reject_request.html',
      show: false
    });

    $scope.reject = function () {
      AuctionParticipationRequest.reject({
        id: $scope.rejectEntity.id,
        rejectReason: $scope.rejectEntity.rejectReason
      }, function () {
        $scope.modalReject.hide();
        delete $scope.rejectEntity.rejectReason;
        $scope.auctionParticipationRequestCrud.reload();
        $scope.auctionParticipationRequestCrud.edit($scope.rejectEntity.id);
        $scope.rejectEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("REJECTED"));
      });
    }

    $scope.onSelect = function (crudScope, entity) {
      crudScope.log = AuctionParticipationRequest.getLog({
        code: entity.id
      });
      crudScope.userDetails = AuctionParticipationRequest.getUserDetails({
        username: entity.user.username
      });
    };
    $scope.actions = [{
      text: 'eauction.approve',
      name: 'approve',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-check',
      enabled: false,
      onClick: function (entity) {
        AuctionParticipationRequest.approve({
          id: entity.id
        }, function () {
          $scope.auctionParticipationRequestCrud.clear();
          $scope.auctionParticipationRequestCrud.reload();
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("APPROVED"));
        });

      }
    }, {
      text: 'eauction.reject',
      name: 'reject',
      position: 'right',
      classes: 'btn btn-danger',
      iconClass: 'fa fa-fw fa-ban',
      enabled: false,
      onClick: function (entity) {
        $scope.rejectEntity.id = entity.id;
        $scope.modalReject.$promise.then($scope.modalReject.show);
      }
    }];

  }
]);
